module.exports = __webpack_public_path__ + "static/media/reportsNavbar.43530116.svg";